/**
* Autogenerated file. Do Not Edit
*/
  import {css} from 'lit';
   
  export const styles = css`
:host {
  display: block;
  padding: 25px;
  color: var(--workable-widget-font-color, var(--color--ink));
  font-family: var(--workable-widget-font, var(--font--body));
  font-size: clamp(16px, 1rem, 22px);
}

li {
  list-style: none;
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

select {
  appearance: none;
  color: inherit;
  font: inherit;
  line-height: inherit;
  font-weight: bold;
  border: none;
  border-bottom: 1px solid var(--select-border);
  background: transparent;
  width: 100%;
  padding: 0.5em 1em 0.5em 0;
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23e600a0'%3E%3Cpath d='M7.406 8.578l4.594 4.594 4.594-4.594 1.406 1.406-6 6-6-6z'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 1.5em;
}

.job-category {
  font-weight: 400;
  font-size: 0.8rem;
}

.job {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--workable-widget-link-color-hover, var(--color--kale-green));
}

.job-title {
  color: var(--workable-widget-link-color, var(--color--ink));
  text-decoration: none;
  line-height: 1.9em;
  font-weight: 100;
  font-family: var(--workable-widget-font-header, var(--font--heading));
  font-size: var(--font-size--h4);
}

.job-title:hover {
  color: var(--workable-widget-link-color-hover, var(--color--kale-green));
  text-decoration: underline;
}

.jobs-list {
  padding-bottom: 1.5rem;
  padding-left: 0;
}

.job-location {
  font-size: var(--font-size--small);
}

.widget-heading {
  font-family: var(--workable-widget-font-header, var(--font--heading));
  color: var(--workable-widget-headline-color);
  font-size: var(--font-size--h3);
  font-weight: 100;
}

/* Tablet and Larger Overrides */
@media (min-width: 600px) {
  .job {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .jobs-list, .widget-heading {
    padding-left: inherit;
  }
}

/*# sourceMappingURL=styles.css.map */
`;
